
import axios from 'axios'
import {mapGetters, mapActions} from 'vuex'
import store from '../../store/index.js'

let http = axios.create({
  timeout: 1000 * 60 * 30,
  baseURL: window.baseUrl,
  withCredentials: false,  
  headers: {
  }
})


// http.adornUrl = (actionName) => {
//   return window.baseUrl + actionName
// }


export function get (url, params) {
  return http(url, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'language': store.getters.language
    },
    method: 'get',
    params: params
  }).then(res => {
    return res.data
  })
}


export function post (url, params) {
  return http(url, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'language': store.getters.language
    },
    method: 'post',
    data: params
  }).then(res => {
    return res.data
  })
}